import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material'

import { useAuth } from '../../auth/hooks/useAuth'
import { DropdownAdminTab } from '../components/DropdownAdminTab'
import { OptionRequestsTab } from '../components/OptionRequestsTab'
import { WorkflowTab } from '../components/WorkflowTab'
import { PublisherPage } from '../../publisher/pages/PublisherPage'

type AdminLocationState = {
  tab?: number
}

export function AdminPage() {
  const location = useLocation()
  const { user } = useAuth()
  const isAdmin = user?.role === 'admin'
  const maxTabIndex = isAdmin ? 3 : 2
  const initialTab = Math.min((location.state as AdminLocationState | null)?.tab ?? 0, maxTabIndex)
  const [tab, setTab] = useState(initialTab)

  return (
    <Box>
      <Paper sx={{ p: 3, mb: 3, borderLeft: '4px solid #0f4c81' }}>
        <Typography variant="h5">Admin Panel</Typography>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          Manage the technote review workflow and configure dropdown options for the submission form.
        </Typography>
      </Paper>

      <Tabs value={tab} onChange={(_, nextTab) => setTab(nextTab)} sx={{ mb: 3, borderBottom: '1px solid #d8e0ea' }}>
        <Tab label="Workflow" sx={{ textTransform: 'none', fontWeight: 700 }} />
        <Tab label="Dropdown Options" sx={{ textTransform: 'none', fontWeight: 700 }} />
        <Tab label="Option Requests" sx={{ textTransform: 'none', fontWeight: 700 }} />
        {isAdmin && <Tab label="Users" sx={{ textTransform: 'none', fontWeight: 700 }} />}
      </Tabs>

      {tab === 0 && <WorkflowTab />}
      {tab === 1 && <DropdownAdminTab />}
      {tab === 2 && <OptionRequestsTab />}
      {isAdmin && tab === 3 && <PublisherPage />}
    </Box>
  )
}
